<template>
  <v-app class="home-page" :key="updateLanguage">
    <header-comp :activeButton="2" access="admin" :userInfo="this.dealersData" v-on:update="onStep1Update()"
    />
    <div class="main-page">
      <div class="container-fluid">
        <div class="row">
          <div class="col col-md-11 mx-auto">
            <div class="user-hdng d-flex align-center justify-content-between">
              <h4>{{ "lng_menu_boxsett" | translate }}</h4>
              <v-btn
                small
                color="#0B7894"
                dark
                @click="openAddBoxModalFunc()"
              >{{ "lng_add_box_txt" | translate }}</v-btn>
            </div>
            <div v-if="systemsData" class="mt-4">
              <div style="overflow-x: auto;">
                
                <table
                  class="table table-bordered table-striped my-4"
                  v-if="systemsData && systemsData.systems && systemsData.systems.length"
                >
                  <thead>
                    <tr>
                      <th>#</th>
                      <th scope="col">{{ "lng_th_systemId" | translate }}</th>
                      <th scope="col">{{ "lng_th_address" | translate }}</th>
                      <th scope="col">{{ "lng_th_alarm_email" | translate }}</th>
                      <th scope="col">{{ "lng_th_alarm_phone" | translate }}</th>
                      <!-- <th scope="col">{{ "lng_th_service_email" | translate }}</th>
                      <th scope="col">{{ "lng_th_days_till_service" | translate }}</th>
                      <th scope="col">{{ "lng_th_operation_email" | translate }}</th> -->
                      <th scope="col">{{ "lng_th_mac_number_txt" | translate }}</th>
                      <th scope="col">{{ "lng_th_service_contract_txt" | translate }}</th>
                      <th scope="col">{{ "lng_th_actions" | translate }}</th>
                    </tr>
                  </thead>
                  <tbody v-for="(item, index) in systemsData.systems" :key="item.system+index">
                    <tr >

                      <td data-toggle="collapse" :data-target="`#collapsedRow${item.system.id}`" class="accordion-toggle collapsed expand-button" @click="getHouseBoxes(item.system)"></td>
                      <th scope="row">{{ item.system.id }}</th>
                      <td>
                        {{item.system | formatAddress}}
                      </td>
                      <td>{{ item.system.alarmemail }}</td>
                      <td>{{ item.system.alarmsms }}</td>
                      <!-- <td>{{ item.system.serviceemail }}</td>
                      <td>{{ item.system.daystillservice }}</td>
                      <td>{{ item.system.operationemail }}</td> -->
                      <td>{{ item.system.mecnumber }}</td>
                      <td>{{ item.system.servicecontract == "1" ? "lng_yes_txt" : "lng_no_txt" | translate }}</td>
                      <td>
                        <div class="d-flex justify-content-center">
                          <v-btn
                            small
                            color="#0B7894"
                            dark
                            @click="openUpdateModal(item.system)"
                          >{{ "lng_update_btn" | translate }}</v-btn>
                        </div>
                      </td>

                      <tr>
                        <td colspan="12" class="hiddenRow">
                          <div class="container-fluid">
                            <table class="table table-striped table-bordered">
                              <thead>
                                <tr>
                                  <th>{{ "lng_th_boxType" | translate }}</th>
                                  <th>{{ "lng_th_boxId" | translate }}</th>
                                  <th>{{ "lng_th_boxPass" | translate }}</th>
                                  <th>{{ "lng_th_actions" | translate }}</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-if="item.devices && item.devices.length > 0">
                                  <td>{{ "lng_sewer_text" | translate }}</td>
                                  <td>{{ item.devices[0].id }}</td>
                                  <td>{{ item.devices[0].pincode }}</td>
                                  <td>
                                    <v-btn
                                      small
                                      color="#0B7894"
                                      dark
                                      @click="openReplaceBoxModal(item.devices[0], item.system.id)"
                                    >{{ "lng_replace_btn" | translate }}</v-btn>
                                  </td>
                                </tr>
                                <tr v-if="item.devices && item.devices.length > 1">
                                  <td>{{ "lng_house_text" | translate }}</td>
                                  <td>{{ item.devices[1].id }}</td>
                                  <td>{{ item.devices[1].pincode }}</td>
                                  <td>
                                    <v-btn
                                      small
                                      color="#0B7894"
                                      dark
                                      @click="openReplaceBoxModal(item.devices[1], item.system.id)"
                                    >{{ "lng_replace_btn" | translate }}</v-btn>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </td>
                      </tr>
                    
                      <tr>
                        <td colspan="12" class="hiddenRow">
                          <div class="accordion-body collapse container-fluid" :id="`collapsedRow${item.system.id}`">
                            
                            <ShowExtraBoxes
                              v-if="findBoxes(item.system)"
                              :extraHouseBoxes="extraHouseBoxes"
                              :systemId="item.system.id"
                              :user-token="userToken"
                              @addNewHouseBox="addNewHouseBox"
                              @refreshHouseBoxes="refreshHouseBoxes"
                            />
                          </div>
                        </td>
                      </tr>

                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-else class="d-flex align-center justify-center">
              <v-progress-circular
                :size="50"
                color="primary"
                indeterminate
              ></v-progress-circular>
            </div>
          </div>
        </div>
      </div>
    </div>
    <updateBoxAddress
      :changeKey="updateBoxKey"
      :complete-address="addressObj"
      :user-token="userToken"
      :dialog-title="'lng_update_box_txt' | translate"
      :openDialog="openBoxModal"
      :closeDialog="closeBoxModalFunct"
      @updateLocalData="fetchSystemsData(userToken)"
    ></updateBoxAddress>
    <ReplaceBoxModal
      :box-id="replaceBoxId"
      :system-id="selectedSystemId"
      :user-token="userToken"
      :dialog-title="replaceBoxTitle"
      :openDialog="openReplaceBoxToggle"
      :closeDialog="closeReplaceBoxModalFunc"
      :addHouseBoxProp="addHouseBoxProp"
      @refreshHouseBoxes="refreshHouseBoxes"
      @updateLocalData="fetchSystemsData(userToken)"
    ></ReplaceBoxModal>
    <AddBoxModal
      :persist="false"
      :complete-address="addressObj"
      :user-token="userToken"
      :dialog-title="'lng_add_box_txt' | translate"
      :openDialog="openAddBoxModal"
      :closeDialog="closeAddBoxFunc"
      @successAddingBox="fetchSystemsData(userToken)"
      :prefilledAddress="false"
    ></AddBoxModal>
  </v-app>
</template>

<script>
import HeaderComp from "../../components/HeaderComp";
import GlobalService from "../../services/global-service";
import updateBoxAddress from "../../components/updateBoxAddress";
import ReplaceBoxModal from "../../components/ReplaceBoxModal";
import AddBoxModal from "../../components/AddBoxModal";
import { translateFunc } from "../../common/Filters.js"
import onStep1Update from "../../mixins/ChangeLanguage"
import ShowExtraBoxes from "../../components/ShowExtraBoxes.vue";


export default {
  name: "AdminDevices",
  components: {
    HeaderComp,
    updateBoxAddress,
    ReplaceBoxModal,
    AddBoxModal,
    ShowExtraBoxes,
  },
  data: () => ({
    systemsData: undefined,
    userToken: undefined,
    dealersData: undefined,
    openBoxModal: false,
    updateBoxKey: 1,
    addressObj: {},
    openReplaceBoxToggle: false,
    replaceBoxTitle: "",
    replaceBoxId: "",
    selectedSystemId: "",
    openAddBoxModal: false,
    extraHouseBoxes: [],
    addHouseBoxProp: false,
  }),
  mounted() {
    this.userToken = sessionStorage.getItem("userToken");
    this.fetchSystemsData(this.userToken);
    this.fetchDealersInfoDevice(this.userToken);
    
  },
  mixins:[onStep1Update],
  methods: {
    async fetchParamsData() {
      const params =  await Promise.resolve(this.$route.params);
      if(params && params.boxItem){
        if(params.editBox)
          this.openUpdateModal(params.boxItem);
        else
          this.openReplaceBoxModal(params.boxItem, params?.systemId)
      }
    },
    async fetchDealersInfoDevice(token){
      let data = await GlobalService.getdealerinfo(token);
      if (data.dealer ) {
        this.dealersData = data.dealer;
      }
    },
    async fetchSystemsData(token) {
      this.systemsData = await GlobalService.getAllBoxesForMap(token);
      this.openAddBoxModal = false;
      if(this.systemsData && this.systemsData.systems){
        this.fetchParamsData();
      }
      // this.openBoxModal = false;
      // this.openReplaceBoxToggle = false;
    },
    closeBoxModalFunct() {
      this.openBoxModal = false;
    },
    openUpdateModal(boxItem) {
      this.addressObj = {
        id: boxItem.id,
        addr1: boxItem.address1,
        addr2: boxItem.address2,
        city: boxItem.city,
        zip: boxItem.zip,
        country: boxItem.country,
        lat: boxItem.geolat,
        lng: boxItem.geolng,
        alarmemail: boxItem.alarmemail,
        serviceemail: boxItem.serviceemail,
        daystillservice: boxItem.daystillservice,
        internalcomment: boxItem.internalcomment,
        operationemail: boxItem.operationemail,
        alarmsms: boxItem.alarmsms,
        alarmprefix: boxItem.alarmprefix,
        mecnumber: boxItem.mecnumber,
        sewertype: boxItem.sewertype,
        uwsequipment: boxItem.uwsequipment,
        servicecontract: boxItem.servicecontract,
        subscription: boxItem.subscription
      };
      this.updateBoxKey += 1;
      this.openBoxModal = true;
    },
    openReplaceBoxModal(boxItem, systemId){
      if(boxItem.devicetype === '0'){
        this.replaceBoxTitle= translateFunc("lng_rplce_sewer_box_txt")
      } else if(boxItem.devicetype === '1'){
        this.replaceBoxTitle= translateFunc("lng_rplce_house_box_txt")
      }
      this.addHouseBoxProp = false;
      this.replaceBoxId = boxItem.id;
      this.selectedSystemId = systemId;
      this.openReplaceBoxToggle = true;
    },
    closeReplaceBoxModalFunc() {
      this.openReplaceBoxToggle = false;
    },
    openAddBoxModalFunc() {
      this.openAddBoxModal = true;
    },
    closeAddBoxFunc() {
      this.openAddBoxModal = false;
    },
    async getHouseBoxes(system) {
      const data = this.extraHouseBoxes && this.extraHouseBoxes.find(e => e.id == system?.id);

      if(!(data && data.id)){
        let data = await GlobalService.getExtraHouseBoxes(this.userToken, system?.id);
        this.extraHouseBoxes.push({ boxes: data, id: system?.id })
      }
    },
    async refreshHouseBoxes(systemId) {
      const index = this.extraHouseBoxes && this.extraHouseBoxes.findIndex(e => e.id == systemId);
      
      let boxes = await GlobalService.getExtraHouseBoxes(this.userToken, systemId);
      if(index !== -1){
        this.extraHouseBoxes[index].boxes = boxes;
      } else {
        this.extraHouseBoxes.push({ boxes, id: systemId })
      }
    },
    findBoxes(system){
      const data = this.extraHouseBoxes && this.extraHouseBoxes.find(e => e.id == system?.id);
      return data && data.id;
    },
    addNewHouseBox(systemId) {
      this.replaceBoxTitle= translateFunc("lng_add_extra_box_txt")
      this.addHouseBoxProp = true;
      this.replaceBoxId = null;
      this.selectedSystemId = systemId;
      this.openReplaceBoxToggle = true;
    },
  }
}
</script>